import React from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

class SelectInspections extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const menuItems = [];

        console.log(this.props.items);
        this.props.items.map(function(item) {
            menuItems.push(<MenuItem key={item.id} value={item.id}>{item.title}</MenuItem>);
        });

        return (<Select disabled={this.props.disabled}
                        fullWidth
                        id={this.props.id}
                        value={this.props.value}
                        onChange={this.props.onChange}>
            {menuItems}</Select>);
    }

}

SelectInspections.propTypes = {
    id: PropTypes.any,
    value: PropTypes.any.isRequired,
    disabled: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    items: PropTypes.array.isRequired
};

SelectInspections.defaultProps = {
    id:"insp-select",
    value: 0,
    items: [],
    disabled: false
};




export default SelectInspections;


// WEBPACK FOOTER //
// ./assets/src/js/components/controls/SelectInspections.jsx